import { differenceInDays, isBefore } from 'date-fns';
import {
  ITEM_HEIGHT,
  ITEM_HEIGHT_COMPACT,
  ITEM_HEIGHT_WITH_LABELS,
  ITEM_LANE_HEIGHT,
  ITEM_LANE_HEIGHT_COMPACT,
  MIN_ITEM_WIDTH,
} from '../TimelineItemConstants';

export const clampStartDateToWindow = (
  normalizedStart: string | undefined,
  timelineStartDate: string,
): string => {
  if (normalizedStart && isBefore(normalizedStart, timelineStartDate)) {
    return timelineStartDate;
  }
  return normalizedStart ?? timelineStartDate;
};

export const clampEndDateToWindow = (
  normalizedFinish: string | undefined,
  timelineEndDate: string,
): string => {
  if (normalizedFinish && isBefore(normalizedFinish, timelineEndDate)) {
    return normalizedFinish ?? timelineEndDate;
  }
  return timelineEndDate;
};

export const calculateItemWidth = (
  startDateToUse: string,
  endDateToUse: string,
  dayWidth: number,
): number => {
  const numDaysInItem = differenceInDays(endDateToUse, startDateToUse) + 1;
  return Math.max(dayWidth * numDaysInItem, MIN_ITEM_WIDTH);
};

export const getSingleLaneHeight = (isCompact: boolean): number =>
  isCompact ? ITEM_LANE_HEIGHT_COMPACT : ITEM_LANE_HEIGHT;

export const getItemHeight = (isCompact: boolean, hasVisibleLabels: boolean): number => {
  if (isCompact) return ITEM_HEIGHT_COMPACT;
  if (hasVisibleLabels) return ITEM_HEIGHT_WITH_LABELS;
  return ITEM_HEIGHT;
};

export const calculateMaxContainerHeight = (
  singleLaneHeight: number,
  maxChildOrder: number,
  hasChildren: boolean,
): number => (hasChildren ? (1 + maxChildOrder + 1) * singleLaneHeight : singleLaneHeight);

export const isOutsideTimelineWindow = (
  hasAnyPlannedDate: boolean,
  startDateToUse: string,
  endDateToUse: string,
  timelineStartDate: string,
  timelineEndDate: string,
): boolean => {
  if (!hasAnyPlannedDate) return true;
  if (isBefore(new Date(timelineEndDate), new Date(startDateToUse))) return true;
  if (isBefore(new Date(endDateToUse), new Date(timelineStartDate))) return true;
  return false;
};
